module.exports = require("./crossfilter").crossfilter;



/*****************
 ** WEBPACK FOOTER
 ** ./~/crossfilter/index.js
 ** module id = 354
 ** module chunks = 1
 **/